import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const AdminPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default AdminPageLayout;